import { ApiOpportunity } from "./opportunity.model";

export class ApiLead extends ApiOpportunity {

}  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/lead.model.ts